<template>
  <tg-form-table
    :caption="title"
    :columns="columns"
    :data="tableData"
    :fenceRow="3"
    :fenceCol="1"
    :columnWidth="250"
    :cellWidth="350"
    showFooter
  >
    <template slot="nickname">
      <el-input v-model="tableData.nickname" class="tg-input col-6" size="small" clearable></el-input>
    </template>
    <template slot="footer">
      <el-row type="flex">
        <el-col :span="12" class="mb-5">
          <tg-document :title="$t('page.member.trial.apply.tip.title')">
            <template v-for="num in 8">
              <tg-document-item
                :key="num"
                :num="num"
                :content="$t('page.member.trial.apply.tip.content[' + (num -1) + ']')"
              ></tg-document-item>
            </template>
          </tg-document>
        </el-col>
        <el-col :span="12" class="mb-5">
          <tg-document :title="$t('page.member.trial.tip.remind.title')">
            <template v-for="num in 2">
              <tg-document-item
                :key="num"
                :num="num"
                :content="$t('page.member.trial.tip.remind.content[' + (num -1) + ']')"
              ></tg-document-item>
            </template>
          </tg-document>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center" align="middle">
        <tg-button
          @click.native="handleSubmit"
          round
          :classes="['tg-btn-prompt--confirm']"
          :disabled="!tableData.nickname"
        >{{$t('component.btn.apply')}}</tg-button>
      </el-row>
    </template>
  </tg-form-table>
</template>

<script>
import TgFormTable from "@/components/table/TgFormTable";
import TgDocument from "@/components/document/TgDocument";
import TgDocumentItem from "@/components/document/TgDocumentItem";
import TgButton from "@/components/button/TgButton";

import apis from "@/apis";
const api = apis.member.trial;

export default {
  components: {
    TgFormTable,
    TgDocument,
    TgDocumentItem,
    TgButton,
  },
  props: {
    l20: String,
  },
  data() {
    return {
      title: this.$t("page.member.trial.apply.caption"),
      columns: [],
      tableData: {},
    };
  },
  computed: {
    request() {
      return {
        targetName: this.l20,
      };
    },
  },
  created() {
    api.getApplyData(this.request).then((response) => {
      this.columns = response.columns;
      this.tableData = response.data;
    });
  },
  methods: {
    handleSubmit() {
      api.apply(this.tableData).then(() => {
        this.$emit("on-success", this.tableData);
      });
    },
  },
};
</script>